import { render, staticRenderFns } from "./TemplateSendTest.vue?vue&type=template&id=528c66b2"
import script from "./TemplateSendTest.vue?vue&type=script&lang=js"
export * from "./TemplateSendTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports